import { Deal } from "@ifgengineering/client-invest-sdk";
import { signInAsync, signOutAsync } from "../auth/auth.actions";
import {
  fetchDealsAPI,
  fetchIfIsaLiveDealsAPI,
  fetchIfIsaTransferDestinationsAPI,
} from "./deal.actions";

export interface DealState {
  neverLoadedDeals: boolean;
  loading: boolean;
  data: Deal[];
  ifIsaLive: IfIsaDealListState;
  ifIsaTransferDestinations: IfIsaDealListState;
}

interface IfIsaDealListState {
  neverLoaded: boolean;
  loading: boolean;
  data: Deal[];
}

export const INITIAL_STATE: DealState = {
  neverLoadedDeals: true,
  loading: false,
  data: [],
  ifIsaLive: {
    neverLoaded: true,
    loading: false,
    data: [],
  },
  ifIsaTransferDestinations: {
    neverLoaded: true,
    loading: false,
    data: [],
  },
};

const dealReducer = (state = INITIAL_STATE, action: any): DealState => {
  switch (action.type) {
    case signInAsync.fulfilled.type:
    case signOutAsync.fulfilled.type:
      return {
        ...INITIAL_STATE,
      };
    case fetchDealsAPI.pending.type:
      return {
        ...state,
        loading: true,
      };
    case fetchDealsAPI.fulfilled.type:
      return {
        ...state,
        loading: false,
        neverLoadedDeals: false,
        data: [...action.payload],
      };
    case fetchIfIsaLiveDealsAPI.pending.type:
      return {
        ...state,
        ifIsaLive: {
          ...state.ifIsaLive,
          loading: true,
        },
      };
    case fetchIfIsaLiveDealsAPI.fulfilled.type:
      return {
        ...state,
        ifIsaLive: {
          ...state.ifIsaLive,
          loading: false,
          neverLoaded: false,
          data: [...action.payload],
        },
      };
    case fetchIfIsaTransferDestinationsAPI.pending.type:
      return {
        ...state,
        ifIsaTransferDestinations: {
          ...state.ifIsaTransferDestinations,
          loading: true,
        },
      };
    case fetchIfIsaTransferDestinationsAPI.fulfilled.type:
      return {
        ...state,
        ifIsaTransferDestinations: {
          ...state.ifIsaTransferDestinations,
          loading: false,
          neverLoaded: false,
          data: [...action.payload],
        },
      };
    default:
      return state;
  }
};

export default dealReducer;
